import React from 'react';
import { ReactComponent as ListAlt } from '../../assets/images/icons/list-all.svg';

export default function ListAltIcon(props) {
  return (
    <ListAlt {...props} className={'icon'} />
  );
}
